module.exports = __webpack_public_path__ + "img/marr.fa3d6619.svg";